import React from 'react'
import { Box, Skeleton, Stack } from '@mui/material'

// Simplified Fortis skeleton per spec:
// - One block for the title
// - One smaller block for the buttons area (tabs)
// - Four fields: each has a small label skeleton and a full-width input skeleton
const FortisSkeleton = () => {
  const Field = ({ labelWidth = '30%' }) => (
    <Stack spacing={0.75}>
      <Skeleton variant="text" width={labelWidth} height={18} />
      <Skeleton variant="rounded" width="100%" height={48} />
    </Stack>
  )

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={theme => ({
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: { xs: 2, sm: 3 },
          minHeight: 517,
          bgcolor: 'background.paper',
        })}
      >
        <Stack spacing={2.25}>
          {/* Title block */}
          <Skeleton variant="text" width="32%" height={28} />

          {/* Buttons (tabs) small block */}
          <Skeleton variant="rounded" width={220} height={36} />

          {/* Four fields */}
          <Field labelWidth="28%" />
          <Field labelWidth="35%" />
          <Field labelWidth="38%" />
          <Field labelWidth="30%" />
        </Stack>
      </Box>
    </Box>
  )
}

export default FortisSkeleton
